import { intlFormat } from 'date-fns';
import { useIntl } from 'react-intl';

export const useFormattedDateTimeInLocale = (date?: string, locale: string = 'en'): string | null => {
  const { formatMessage } = useIntl();
  if (!date) {
    return null;
  }
  const dateObj = new Date(date);
  if (isNaN(dateObj.getTime())) {
    return null;
  }

  const formattedDate = intlFormat(
    dateObj,
    {
      month: 'short',
      day: 'numeric',
      year: 'numeric',
      weekday: 'short',
    },
    { locale },
  );
  const formattedTime = intlFormat(dateObj, { timeStyle: 'short' }, { locale });

  const formattedDateTime = formatMessage(
    {
      id: '{date} at {time}',
      defaultMessage: '{date} at {time}',
      description: 'Example string is Tue, Nov 18, 2025 at 8:00 PM',
    },
    {
      date: formattedDate,
      time: formattedTime,
    },
  );

  return formattedDateTime;
};
